import type { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/settings/notifications/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/settings/notifications';

const Home: NextPage = () => (
  <>
    <NskHead title="通知設定" />
    <Component />
  </>
);

export default Home;
